/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Registry_Cee_Uses_IcoInputs */

const cs_property_registry_cee_uses_ico = /** @type {(inputs: Property_Registry_Cee_Uses_IcoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Použije IČO z pole ARES vlevo.`)
};

const en_property_registry_cee_uses_ico = /** @type {(inputs: Property_Registry_Cee_Uses_IcoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uses the IČO from the ARES field on the left.`)
};

/**
* | output |
* | --- |
* | "Uses the IČO from the ARES field on the left." |
*
* @param {Property_Registry_Cee_Uses_IcoInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_registry_cee_uses_ico = /** @type {((inputs?: Property_Registry_Cee_Uses_IcoInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Registry_Cee_Uses_IcoInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_registry_cee_uses_ico(inputs)
	return cs_property_registry_cee_uses_ico(inputs)
});